declare global {
    interface Window {
        __PG_RP_DATA_LAYER_PUSH_DEFERRED__?: boolean;
    }
}

export const deferDataLayerPushAfterLoad = (): void => {
    if (process.env.EXEC_ENV !== "browser" || typeof window === "undefined") {
        return;
    }

    const win = window as Window;

    if (win.__PG_RP_DATA_LAYER_PUSH_DEFERRED__) {
        return;
    }

    win.__PG_RP_DATA_LAYER_PUSH_DEFERRED__ = true;

    const installDeferredPush = () => {
        win.dataLayer = win.dataLayer || [];

        const dataLayer = win.dataLayer;
        const originalDataLayerPush = dataLayer.push;

        dataLayer.push = (...args: object[]) => {
            requestAnimationFrame(() => {
                setTimeout(() => {
                    originalDataLayerPush.apply(dataLayer, args);
                }, 0);
            });

            return dataLayer.length;
        };
    };

    if (document.readyState === "complete") {
        installDeferredPush();
        return;
    }

    win.addEventListener("load", installDeferredPush, {once: true});
};
declare global {
    interface Window {
        __PG_RP_DATA_LAYER_PUSH_DEFERRED__?: boolean;
    }
}

export const deferDataLayerPushAfterLoad = (): void => {
    if (process.env.EXEC_ENV !== "browser" || typeof window === "undefined") {
        return;
    }

    const win = window as Window;

    if (win.__PG_RP_DATA_LAYER_PUSH_DEFERRED__) {
        return;
    }

    win.__PG_RP_DATA_LAYER_PUSH_DEFERRED__ = true;

    const installDeferredPush = () => {
        win.dataLayer = win.dataLayer || [];

        const dataLayer = win.dataLayer;
        const originalDataLayerPush = dataLayer.push;

        dataLayer.push = (...args: object[]) => {
            requestAnimationFrame(() => {
                setTimeout(() => {
                    originalDataLayerPush.apply(dataLayer, args);
                }, 0);
            });

            return dataLayer.length;
        };
    };

    if (document.readyState === "complete") {
        installDeferredPush();
        return;
    }

    win.addEventListener("load", installDeferredPush, {once: true});
};
